export default 'M7 11V1H4v10a8 8 0 1 0 16 0V1h-3v10a5 5 0 0 1-10 0M4 23h16v-3H4z';